import { render, staticRenderFns } from "./HeaderTeamRequestStatus.vue?vue&type=template&id=bf27c718&scoped=true"
import script from "./headerTeamRequestStatus.ts?vue&type=script&lang=ts&external"
export * from "./headerTeamRequestStatus.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf27c718",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf27c718')) {
      api.createRecord('bf27c718', component.options)
    } else {
      api.reload('bf27c718', component.options)
    }
    module.hot.accept("./HeaderTeamRequestStatus.vue?vue&type=template&id=bf27c718&scoped=true", function () {
      api.rerender('bf27c718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/team-request-detail/header-team-request-status/HeaderTeamRequestStatus.vue"
export default component.exports